import { BookingTypeEnum, InvestmentTypeEnum } from "@rentablo/api/apiv1";

export const investmentTypeToAccountType = (type: InvestmentTypeEnum) =>
  ["61_pmetals", "71_massets"].includes(type)
    ? "05_material_assets"
    : "01_depot";

export const isCapitalMeasure = (type: BookingTypeEnum) => {
  return ["carve_out", "switch"].includes(type);
};
